import i18n from '@/i18n';

export default {
  methods: {
    formatDate(date) {
      const lang = i18n.locale;
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Intl.DateTimeFormat(lang, options).format(new Date(date));
    },
  },
};
